import { render, staticRenderFns } from "./dashboardLayout.vue?vue&type=template&id=39fbe1ca&scoped=true&"
import script from "./dashboardLayout.vue?vue&type=script&lang=js&"
export * from "./dashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fbe1ca",
  null
  
)

export default component.exports